import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-recommend-form__modal-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "業種を選択", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "p-recommend-form__modal-body" }
const _hoisted_5 = { class: "p-recommend-form__modal-aside" }
const _hoisted_6 = ["data-tab", "onClick"]
const _hoisted_7 = ["id"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "p-recommend-form__modal-list-1" }
const _hoisted_11 = { class: "p-login-form__radio" }
const _hoisted_12 = ["id", "name", "checked", "onChange", "value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "p-recommend-form__modal-foot" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "指定する", -1)
const _hoisted_17 = [
  _hoisted_16
]

import { DialogIndustryData, Level1MstIndustry, Level2MstIndustry } from '@/types/mstMyPage';
import { domHelperUtils } from '@/utils/domHelper';
import { onMounted, ref, computed, watch, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';

export default /*#__PURE__*/_defineComponent({
  __name: 'IndustryRadio',
  props: {
    selectedIndustry: null,
    isActive: { type: Boolean },
    name: null,
    nameElement: null
  },
  emits: ["update:selectedIndustry", "update:isActive", "update:setValue"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'update:selectedIndustry',
    value: {
      indsctgId: number | null;
      indsctgText: string;
    }
  ): void;
  (e: 'update:isActive', value: boolean): void;
  (
    e: 'update:setValue',
    value: {
      indsctgId: number | null;
      indsctgText: string;
      name?: string;
    }
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  selectedIndustry?: {
    indsctgId: number | null;
    indsctgText: string;
  };
  isActive: boolean;
  name: string;
  nameElement?: string;
}

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const dialogData = ref<DialogIndustryData>();
const currentTab = ref(0);
const modalClass = ref({
  'is-active': false,
});

// Props/Emitsの設定


watch(
  () => props.isActive,
  (newVal) => {
    modalClass.value['is-active'] = newVal;
    if (newVal && props.selectedIndustry) {
      updateCheckboxesFromIds(props.selectedIndustry);
    }

    // Add or remove event listener based on modal state
    if (newVal) {
      document.addEventListener('keydown', handleKeyDown);
      domHelperUtils.disableBodyScroll();
    } else {
      document.removeEventListener('keydown', handleKeyDown);
      domHelperUtils.enableBodyScroll();
    }
});
// Handle keydown events
const handleKeyDown = (event: KeyboardEvent): void => {
  // Close modal when ESC key is pressed
  if (event.key === 'Escape' || event.key === 'Esc') {
    hideDialog();
  }
};



// 選択された業種の計算プロパティ
const selectedIndustry = computed(() => {
  if (!dialogData.value)
    return {
      indsctgId: null,
      indsctgText: '',
    };

  const result = {
    indsctgId: null as number | null,
    indsctgText: '',
  };

  dialogData.value.selectbox1.forEach((box1, i) => {
    // selectbox1がチェックされていない場合、チェックされているselectbox2のIDをjobsearchIndsctgIdに追加
    box1.selectbox2.forEach((box2) => {
      if (box2.isChecked && !box2.id.toString().endsWith('00')) {
        result.indsctgId = Number(box2.id);
        result.indsctgText = box2.text;

        currentTab.value = i;
        box1.isOpened = true;
      }
    });
  });

  return result;
});

// 条件をクリア
function clearAllSelections(isResetTab = true) {
  if (!dialogData.value) return;

  if (isResetTab) currentTab.value = 0;

  // すべてのチェックボックスの選択を解除
  dialogData.value.selectbox1.forEach((box1) => {
    // 第1階層のチェックボックスをクリア
    box1.isChecked = false;

    if (isResetTab) box1.isOpened = false;
    box1.selectbox2.forEach((box2) => {
      // 第2階層のチェックボックスをクリア
      box2.isChecked = false;
    });
  });
}

// 指定する
function submitSelection(isFromOnMounted = false) {
  emit('update:selectedIndustry', selectedIndustry.value);
  emit('update:isActive', false);
  if (!isFromOnMounted) {
    emit('update:setValue', {
      indsctgId: selectedIndustry.value.indsctgId,
      indsctgText: selectedIndustry.value.indsctgText,
      name: props.nameElement,
    });
  }
}

// IDリストからチェックボックスの状態を更新
function updateCheckboxesFromIds(selectedData: { indsctgId: number | null; indsctgText: string }) {
  if (!dialogData.value) return;

  clearAllSelections();

  dialogData.value.selectbox1.forEach((box1, i) => {
    box1.selectbox2.forEach((box2) => {
      if (!box2.id.toString().endsWith('00') && selectedData.indsctgId == Number(box2.id)) {
        box2.isChecked = true;

        currentTab.value = i;
        box1.isOpened = true;
      }
    });
  });

  // re-open checked sections
  const openedItems = document.querySelectorAll(`#industry-radio-dialog-body${props.name.replace('.', '\\.')} .p-recommend-form__modal-list-1-wrap.-is-opened`);
  openedItems.forEach(item => {
    if ((item as HTMLElement).style.display == 'none') {
      (item as HTMLElement).style.display = '';
    }
  });
}

function hideDialog() {
  modalClass.value['is-active'] = false;
  emit('update:isActive', false);
}

const store = useStore();
onMounted(async () => {
  dialogData.value = await store.dispatch(storeBase.DIALOG_INDUSTRY);
  clearAllSelections();
  // 初期選択値があれば設定
  if (props.selectedIndustry && props.selectedIndustry.indsctgId) {
    updateCheckboxesFromIds(props.selectedIndustry);
    submitSelection(true);
  }

  // Add event listener if modal is active on mount
  if (props.isActive) {
    document.addEventListener('keydown', handleKeyDown);
  }
});

// Clean up event listener when component is unmounted
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

// 第2階層チェックボックスの状態変更を処理する関数
function handleCheckbox2(checkbox: Level2MstIndustry, isChecked: boolean) {
  clearAllSelections(false);
  // 第2階層チェックボックスの状態を更新
  checkbox.isChecked = isChecked;
}

function toggleBox1(target: HTMLElement, box1: Level1MstIndustry) {
  const radContainer = target.nextElementSibling as HTMLElement;
  if (radContainer) {
    if (box1.isOpened) {
      domHelperUtils.toggle.initOpen(radContainer);
      domHelperUtils.toggle.closeAccordion(radContainer);
    } else {
      domHelperUtils.toggle.openAccordion(radContainer);
    }
  }
  box1.isOpened = !box1.isOpened;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-recommend-form__modal", modalClass.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", {
        class: "p-recommend-form__modal-close",
        onClick: hideDialog
      }, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (item, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: _normalizeClass({ __current: i == currentTab.value }),
              "data-tab": `industry-tab${i + 1}`,
              onClick: ($event: any) => (currentTab.value = i)
            }, [
              _createElementVNode("span", null, _toDisplayString(item.text), 1)
            ], 10, _hoisted_6))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "p-recommend-form__modal-content",
          id: `industry-radio-dialog-body-${__props.name}`
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dialogData.value?.selectbox1, (box1, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: box1.id,
              class: _normalizeClass(["p-recommend-form__modal-tab", { __current: i == currentTab.value }]),
              id: `industry-tab${i + 1}`
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass(["p-recommend-form__modal-heading-1", { '-is-opened': box1.isOpened }]),
                onClick: ($event: any) => (toggleBox1($event.target as HTMLElement, box1))
              }, _toDisplayString(box1.text), 11, _hoisted_9),
              _createElementVNode("div", {
                class: _normalizeClass(["p-recommend-form__modal-list-1-wrap", { '-is-opened': box1.isOpened }])
              }, [
                _createElementVNode("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(box1.selectbox2.filter((b2) => !b2.id.toString().endsWith('00')), (box2, j) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: box2.id
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        _createElementVNode("input", {
                          id: `form-industry-list-${__props.name}${i}${j}`,
                          type: "radio",
                          name: `form-industry-list-${__props.name}`,
                          checked: box2.isChecked,
                          onChange: ($event: any) => (handleCheckbox2(box2, ($event.target as HTMLInputElement).checked)),
                          value: box2.id
                        }, null, 40, _hoisted_12),
                        _hoisted_13
                      ]),
                      _createElementVNode("label", {
                        class: "p-recommend-form__label",
                        for: `form-industry-list-${__props.name}${i}${j}`
                      }, _toDisplayString(box2.text), 9, _hoisted_14)
                    ]))
                  }), 128))
                ])
              ], 2)
            ], 10, _hoisted_8))
          }), 128))
        ], 8, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("button", {
          class: "p-recommend-form__modal-set js-modal-set",
          type: "button",
          onClick: _cache[0] || (_cache[0] = () => submitSelection())
        }, _hoisted_17)
      ])
    ]),
    _createElementVNode("div", {
      class: "p-recommend-form__modal-close-area",
      onClick: hideDialog
    })
  ], 2))
}
}

})